import { axiosInstance } from "../../../api/axiosInstance.tsx";

export interface LocationSearchParams {
  keyword?: string;
  locationName?: string;
  city?: string;
  province?: string;
  district?: string;
  country?: string;
  mapsLocation?: string;
  startDate?: string;
  endDate?: string;
  limit?: number;
  offset?: number;
  orderBy?: string;
  order?: string;
}

export const getLocations = async (params: LocationSearchParams = {}) => {
  const response = await axiosInstance.get("/locations/search_locations", {
    params,
  });
  return response.data;
};


// Step 1: Create Location
export const createLocation = async (data) => {
  const formData = {
    locationName : data.locationName,
    city : data.city,
    province : data.province,
    district : data.district,
    country : data.country,
    mapsLocation : data.longitude+','+data.latitude,
    longitude : data.longitude,
    latitude : data.latitude,
  };

  const response = await axiosInstance.post(`/locations/create_location`, formData);
  return response.data; // contains the location `id` or `code`
};

// Step 2: Upload Photo by Location ID
export const uploadLocationPhoto = async (locationId, file) => {
  const formData = new FormData();
  formData.append("photo", file);

  return axiosInstance.post(`/locations/upload_photo/${locationId}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};


// Edit Location
export const editLocation = async (data) => {
  const formData = {
    locationName : data.locationName,
    city : data.city,
    province : data.province,
    district : data.district,
    country : data.country,
    mapsLocation : data.longitude+','+data.latitude,
    longitude : data.longitude,
    latitude : data.latitude,
  };

  const response = await axiosInstance.put(`/locations/update_location/${data.locationId}`, formData);
  return response.data; // contains the location `id` or `code`
};

export const deleteLocation = async (locationId: string) => {
  const response = await axiosInstance.delete(`/locations/delete_location/${locationId}`);
  return response.data;
};
